import React, { useEffect, useState } from "react";
import SuccessImage from "../assets/undraw_winners_ao2o1.svg";
import GoogleImage from "../assets/google-button.svg";
import AppleImage from "../assets/apple_store.png";
import { useHistory } from "react-router-dom";

export default function Success({ navigation }) {
  const [accountNumber, setAccountNumber] = useState("");
  const [customerNumber, setCustomerNumber] = useState("");
  const [AccountName, setAccountName] = useState("");
  const { go } = navigation;

  const closeApp = () => {
    window.location.href = "/accountOpeningV2";
    //go("bvn");
    // window.close();
  };
  useEffect(() => {
    let data = JSON.parse(sessionStorage.getItem("deets"));
    let title = sessionStorage.getItem("deetsTitle");
    setAccountNumber(data.AccountNUBAN);
    setCustomerNumber(data.CustomerNumber);
    setAccountName(title + " " + data.AccountName);
  }, []);

  const clientData = JSON.parse(sessionStorage.getItem("body"));
 

  return (
    <div className="row">
      <div className="col-md-10 offset-md-1">
        <div className="header d-flex justify-content-between">
          <div>
            <h1 className="font-weight-bold">All Done!</h1>
            <h4 className="text-warning">Welcome to future forward banking.</h4>
          </div>
          <div>
            <img src={SuccessImage} alt="" width="300" />
          </div>
        </div>

        <div className="infocard p-5 mb-5">
          <p>
            Congratulations! Your <b className="text-warning">ProvidusBank</b>{" "}
            account has been opened. We are glad to have you on board. Your
            account number is{" "}
            <b className="text-danger underline">{accountNumber}.</b> and your
            customer number is{" "}
            <b className="text-danger underline">{customerNumber}</b>
          </p>

          <p>
            With your <b className="text-warning">ProvidusBank</b> account, you
            can now enjoy:
          </p>

          <ul>
            <li>
              <h6>MOBILE BANKING</h6>
            </li>

            <span className="text-muted">
              Bank on the go with our easy to use Mobile Banking App.
            </span>

            <br />

            <br />

            <li>
              <h6>INTERNET BANKING</h6>

              <span className="text-muted">
                Use our online banking application to carry out banking
                transactions at your convenience.
              </span>
            </li>

            <br />

            <br />

            <li>
              <h6>ONLINE PAYMENTS</h6>

              <span className="text-muted">
                Use your account or debit card to pay online on various
                websites.
              </span>
            </li>

            <br />

            <br />

            <li>
              <h6>DISCOUNT SHOPPING</h6>

              <span className="text-muted">
                Enjoy discounts at our partner stores and hotels accross all
                states in Nigeria.
              </span>
            </li>
          </ul>

          <div className="next">
            <h1>Next Steps</h1>

            <ul>
              <li>
                <h6>MEET OUR BUSINESS CONCEIRGE</h6>

                <span className="text-muted">
                  As your account has been opened, a Relationship Manager has
                  been assigned to you to help you manage your account and
                  present you opportunities to grow your wealth. Details of your
                  assigned RM has been sent to your email.
                </span>
              </li>

              <br />

              <br />

              <li>
                <h6>INTERNET BANKING REGISTRATION</h6>

                <span className="text-muted">
                  Follow the steps in the email sent to you to enable your
                  account for internet banking.
                </span>
              </li>

              <br />

              <br />

              <li>
                <h6>MOBILE BANKING REGISTRATION</h6>

                <span className="text-muted">
                  Follow the steps in the email sent to you to enable your
                  account for mobile banking.
                </span>
              </li>

              <br />

              <br />

              <li>
                <h6>DEBIT &amp; CREDIT CARDS</h6>

                <span className="text-muted">
                  Select a card from our varieties of debit and credit cards to
                  suit your lifestyle.
                </span>
              </li>

              <br />

              <br />

              <p>
                CLick <button  onClick={() => closeApp()}>here</button> to return
              </p>

              <br />
            </ul>

            <p>
              You can also download our mobile app “ProvidusPlus” from the
              Playstore for{" "}
              <a
                href="https://play.google.com/store/apps/details?id=com.providus.providusbank"
                target="_blank"
                className="text-warning"
                style={{ marginRight: "2px", textDecoration: "none" }}
              >
                Android
              </a>
              {/* https://play.google.com/store/apps/details?id=com.providus.providusbank */}
              or App store for
              <a
                href="https://apps.apple.com/us/app/providusplus/id1566859972"
                target="_blank"
                className="text-warning"
                style={{ marginLeft: "2px", textDecoration: "none" }}
              >
                IOS
              </a>
              .
            </p>

            <div className="row">
              <div className="col-md-6">
                <a
                  href="https://play.google.com/store/apps/details?id=com.providus.providusbank"
                  target="_blank"
                >
                  <img src={GoogleImage} alt="" width="200" />
                </a>
              </div>

              <div className="col-md-6">
                <a
                  href="https://apps.apple.com/us/app/providusplus/id1566859972"
                  target="_blank"
                >
                  <img src={AppleImage} alt="" width="200" />
                </a>
              </div>
            </div>

            <span className="lead text-warning">
              You can find out more information at{" "}
              <a className="text-warning" href="https://www.providusbank.com/">
                https://www.providusbank.com
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
